import {
  PouzitiePredpis as PouzitiePredpisGenerated,
  PouzitiePredpisListApi,
} from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import PouzitiePredpis from '../model/PouzitiePredpis';
import apiConfiguration from './configuration/apiConfiguration';
import { tezauryPrefixPath } from './configuration/apiConfigurationConstants';
import { ClientResponse } from '../model/ClientResponse';
import Uuid from '../model/Uuid';
import { SHOW_ALL_MAX_RESULT } from '../constants/MultiSelectConstant';

const client = new PouzitiePredpisListApi(apiConfiguration(tezauryPrefixPath));

function map(predpisList: PouzitiePredpisGenerated[]): PouzitiePredpis[] {
  return predpisList.map(predpis => ({
    uuid: predpis.uuid,
    popis: predpis.popis,
    url: predpis.url,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchPouzitiePredpisList = async (
  searchText: string,
  ids: Array<Uuid>,
  limit = SHOW_ALL_MAX_RESULT,
  options: { headers?: AxiosRequestHeaders } = {},
):
  Promise<ClientResponse<PouzitiePredpis[]>> => {
  if (!ids) {
    return {
      data: [],
      responseCode: null,
    };
  }
  const {
    data,
    status,
  } = await client.getPouzitiePredpisList(searchText, ids, limit, options);
  return {
    data: data ? map(data) : [],
    responseCode: status,
  };
};
